import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import {
  SignIn,
  ScreeningResults,
  ActionPlan,
  StrategyQuestions,
  ActionPlanContent,
  BarrierQuestions,
  LandingPage,
  IdentifiedBarriers,
} from "./pages";
import useAuth from "./hooks/useAuth";
import { Box } from "@mui/material";
import { AppProvider } from "./context/AppContext";

function AuthenticatedApp() {
  const { user, loadingInitial } = useAuth();
  
  useEffect(() => {
    if (loadingInitial) {
      return
    };
  }, [user]);

  if (loadingInitial) {
    return <Box>
      Loading...
    </Box>;
  }

  return (
    <>
      {user ? (
        <AppProvider>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/LandingPage" element={<LandingPage />} />
            <Route path="/BarrierQuestions/:id" element={<BarrierQuestions />} />
            <Route path="/ScreeningResults" element={<ScreeningResults />} />
            <Route path="/ActionPlan" element={<ActionPlan />} />
            <Route path="/StrategyQuestions/:id" element={<StrategyQuestions />} />
            <Route path="/ActionPlanContent/:id" element={<ActionPlanContent />} />
            <Route path="/IdentifiedBarriers" element={<IdentifiedBarriers />} />
            <Route path="/" element={<LandingPage />} /> {/* Default route */}
          </Routes>
        </AppProvider>
      ) : (
        <Routes>
          <Route path="/" element={<SignIn />} />
          <Route path="/SignIn" element={<SignIn />} />
        </Routes>
      )}
    </>
  );
}

export default AuthenticatedApp;
